module.exports = __webpack_public_path__ + "static/media/adv_mindfulness_control-en.d359fb76.vtt";